

$(document).ready(function () {

   /* $('.banner').insertBefore('.content-page-row');*/


});